import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { ActivatedRoute, Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { finalize, Subject } from 'rxjs';
import { EventDetailsComponent } from 'src/app/components/dialog/event-details/event-details.component';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { Event } from 'src/app/model/event.model';
import { ROUTES } from 'src/app/route/routes';
import { EventService } from 'src/app/service/event.service';
import { HomeService } from 'src/app/service/home.service';
import { UserService } from 'src/app/service/user.service';
import { LANGUAGES } from 'src/app/constants/lang';
import { Flux, FluxService } from 'src/app/service/flux-service';

@Component({
  selector: 'app-home-landing',
  templateUrl: './event-list.component.html',
  styleUrls: ['./event-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class EventListComponent implements OnInit, OnDestroy {
  flux: Flux = 'spa'
  private destroy$ = new Subject<void>();
  @ViewChild(MatSelectionList) events: MatSelectionList;

  // isLoading: boolean = true;
  isComplete: boolean = false;
  hasEvents: boolean = false;

  eventsList: Array<Event> = new Array<Event>();
  selectedEvent: Event | undefined;

  userLanguage: string;
  public languages = LANGUAGES;

  constructor(
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
    private eventService: EventService,
    private homeService: HomeService,
    private dialog: MatDialog,
    private spinner: SpinnerService,
    private userService: UserService,
    private fluxService: FluxService
  ) {}

  ngOnInit() {
    this.spinner.show();

    this.userLanguage = this.userService.lang;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.userLanguage = event.lang;
    });

    this.fluxService.initializeFromRoute(this.route);
    this.flux = this.fluxService.getCurrentFlux();
    this.eventService
      .getEvents(this.flux)
      .pipe(
        finalize(() => {
          // this.isLoading = false;
          this.spinner.hide();
        })
      )
      .subscribe({
        next: (res) => {
          if (res) {
            this.eventsList = res;
            this.hasEvents = this.eventsList.length != 0;
          }
          this.spinner.hide();
        },
        error: (err) => {
          // console.error(err);
          this.hasEvents = false;
          this.spinner.hide();
        },
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  eventSelected(event: Event) {
    this.selectedEvent = event;

    if (event.sold_out) {
      return;
    }

    const dialogRef = this.dialog.open(EventDetailsComponent, {
      data: {
        event_name: event.event_name,
        event_long_description: event.event_long_description,
        event_dates: event.event_dates,
        event_location: event.event_location,
        event_category_name: event.event_category_name,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.goTo('calendar');
    });
  }

  goTo(path: string) {
    switch (path) {
      case 'calendar': {
        if (this.selectedEvent) {
          this.homeService.saveEventObject(this.selectedEvent);
          this.router.navigate([this.flux+'/'+ ROUTES.EVENT_CALENDAR.path]);
        }
        break;
      }

      case 'home': {
        this.router.navigate([ROUTES.HOME.path]);
        break;
      }
    }
  }
}


